App.factory('Register', ['restmod', restmod => {
    return restmod.model('/account_requests')
}])
